<script>
    import {Date, Icon, FlexList} from "@intellectability/platform-common/sv";
    import {userSecurity} from "@intellectability/platform-common/sv/state";

    import {Card, CardBody, CardFooter} from "@sveltestrap/sveltestrap";

    let uid = userSecurity?.loggedInUser?.id ?? "";

    let {loading, fixedHeight, cardData, tableData = []} = $props();

    let {
        card_name: cardName,
        card_url: cardURL = "",
        card_subtype: cardSubtype
    } = $derived(cardData);

    let cardLink = $derived(process_url(cardURL));
    let columns = $derived.by(function () {
        if (tableData.length > 0) {

            if (cardSubtype === "Linked") {
                // this card has a preset column list
                return [
                    {
                        name: "Title",
                        field: "training_title",
                        sortable: true,
                        filterable: true,
                        collapse: false
                    },
                    {
                        name: "Start",
                        field: "start_display",
                        sortable: true,
                        filterable: true,
                        cell: dateCell,
                        collapse: false
                    },
                    {
                        name: "Link",
                        field: "start_display",
                        cell: linkCell,
                        collapse: false
                    }
                ];
            }
            else {
                // build table based on data
                let keys = Object.keys(tableData[0]);
                //filter out id colum
                return keys.filter(k => !k.includes("id")).map((key, index) => {
                    return {
                        name: key,
                        field: key,
                        collapse: false,
                        sortable: true,
                        filterable: true
                    };
                });
            }
        }
        return [];
    });

    function process_url(cardURL = "") {
        if (cardURL && cardURL.length > 0) {
            if (cardURL.includes("{")) { // we have a template
                // I only know about this one
                return cardURL.replace("{LOGGED_IN_USER_ID}", uid);
            }
        }
        return cardURL ?? "";
    }

</script>

<Card class="mt-2">
    <CardBody>
        <h4>{cardName}</h4>
        <FlexList
                columns={columns}
                data={tableData}
                {loading}
                pagerConfig={{show:false}}
        ></FlexList>
    </CardBody>
    {#if cardLink.length > 0}
        {@render detailsButton?.(() => window.location.href = cardLink)}
    {/if}
</Card>

{#snippet linkCell({link})}
    <wa-button href={link} size="small" variant="brand" target="_blank" class="my-1">
        <wa-icon name="link" variant="solid"></wa-icon>
    </wa-button>
{/snippet}

{#snippet dateCell(row)}
    <Date mysqlDateString={row.start}></Date>
{/snippet}

<style>
    :global(td) {
        vertical-align: middle;
    }

</style>

{#snippet detailsButton(handler, text = "View Details")}
    <CardFooter class="p-0">
        <button
                class="btn link-secondary shadow-none py-2 w-100 rounded-top-0"
                onclick={() => handler?.()}>
            <Icon icon="table"/>
            {text}
        </button>
    </CardFooter>
{/snippet}